"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _icons = require("./icons");
var _icon = require("./icon.tokens");
var _jsxRuntime = require("react/jsx-runtime");
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "sc-1v8ike-0"
})(["display:flex;"]);
var Svg = _styledComponents.default.svg.withConfig({
  displayName: "Icon__Svg",
  componentId: "sc-1v8ike-1"
})(["pointer-events:none;", ""], function (_ref) {
  var color = _ref.color,
    newColor = _ref.newColor,
    customColor = _ref.customColor;
  return (color || newColor || customColor) && (0, _styledComponents.css)(["path{fill:", ";}"], customColor ? customColor : newColor ? _icon.tokens.newColor[newColor] : _icon.tokens.color[color || 'default']);
});
var Icon = function Icon(_ref2) {
  var size = _ref2.size,
    icon = _ref2.icon,
    color = _ref2.color,
    newColor = _ref2.newColor,
    customColor = _ref2.customColor,
    otherProps = _objectWithoutProperties(_ref2, ["size", "icon", "color", "newColor", "customColor"]); // Separate SVG-specific and div-specific props
  var svgProps = {
    width: _icon.tokens.size[size],
    height: _icon.tokens.size[size],
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    color: color,
    newColor: newColor,
    customColor: customColor
  };
  return /*#__PURE__*/ /* we have some components that rely on being able to pass any type of prop to the icon, like style, dataType */(0, _jsxRuntime.jsx)(IconWrapper, _objectSpread({}, otherProps, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Svg, _objectSpread({}, svgProps, {
      children: _icons.icons[icon]
    }))
  }));
};
exports.Icon = Icon;
Icon.defaultProps = {
  size: 'm',
  color: 'default'
};